<div class="modal fade" id="modal-questao-texto" tabindex="-1" aria-labelledby="modal-questao-texto" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="dialogTitle">{{ titulo }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div>         
          <div class="row"> 
              <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                      <label class="label-field" for="descricaoTecnica">{{ descricao }}</label>
                      <textarea [ngModelOptions]="{standalone: true}" [(ngModel)]="texto" class="form-select" [placeholder]="placeholder">
                      </textarea>
                  </div>                    
              </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <ng-container *ngIf="mostrarNovaRevisao; else layoutPadrao">
          <button type="button" class="btn btn-secondary" (click)="onCancelar()">{{ descricaoButtonFechar }}</button>
          <button type="button" class="btn btn-warning" (click)="onNovaRevisao()">{{ descricaoButtonNovaRevisao }}</button>
          <button type="button" class="btn btn-success" [disabled]="obrigatorio && texto.trim() == ''" (click)="onSalvar()">{{ descricaoButtonSim }}</button>
        </ng-container>
        <ng-template #layoutPadrao>
          <button type="button" class="btn btn-danger" (click)="onNao()">{{ descricaoButtonFechar }}</button>
          <button *ngIf="showCancelar" type="button" class="btn btn-secondary" (click)="onCancelar()"><i class='bx bx-x me-1'></i>{{ descricaoButtonCancelar }}</button>
          <button type="button" class="btn btn-success" [disabled]="obrigatorio && texto.trim() == ''" (click)="onSim()">{{ descricaoButtonSim }}</button>
        </ng-template>
      </div>
    </div>
  </div>
</div>